import {
  ContractsWhereColumn,
  OrdersWhereColumn,
  OtherDocumentsWhereColumn,
} from "@src/__generated__/urql-graphql";
import { BaseMixedFilters } from "../../documents/listing/MixedFilters";

export class MixedFilters extends BaseMixedFilters {
  constructor(clientId?: string) {
    super();

    this.where.contracts.hide([
      ContractsWhereColumn.ClientId,
      ContractsWhereColumn.ContractorId,
    ]);
    this.where.orders.hide([
      OrdersWhereColumn.BrandId,
      OrdersWhereColumn.ProjectId,
    ]);
    this.where.otherDocuments.hide([]);

    if (clientId) {
      this.where.contracts.addImplicitFilter(
        ContractsWhereColumn.ClientId,
        clientId,
      );
      this.where.orders.addImplicitFilter(OrdersWhereColumn.ClientId, clientId);
      this.where.otherDocuments.addImplicitFilter(
        OtherDocumentsWhereColumn.ClientId,
        clientId,
      );
    }
  }
}
